import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { useTranslation } from "react-i18next"

interface RenameItemDialogProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  itemType: 'organization' | 'workspace' | 'board'
  currentName: string
  onConfirm: (newName: string) => void
  value: string
  onChange: (value: string) => void
}

export function RenameItemDialog({
  isOpen,
  onOpenChange,
  itemType,
  currentName,
  onConfirm,
  value,
  onChange,
}: RenameItemDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('Rename')} {itemType}</DialogTitle>
          <DialogDescription>
            {t('Enter new name for')} {currentName}
          </DialogDescription>
        </DialogHeader>
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('Enter new name')}
        />
        <DialogFooter>
          <Button onClick={() => onConfirm(value)}>{t('Save')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}